// Three-part legend per Adam msg #428: ramp (real scores) + grey swatch (no score)
// + mandatory caption. G7 honesty: grey is visually distinct from any ramp colour.

export function Legend() {
  return (
    <div className="ps-legend" role="note">
      <div className="ps-legend__title">Upzone potential</div>
      <div className="ps-legend__sub">unincorporated Miami-Dade only · v1</div>
      <div className="ps-legend__ramp" aria-hidden="true" />
      <div className="ps-legend__scale">
        <span>low</span><span>high</span>
      </div>
      <div className="ps-legend__noscore">
        <span className="ps-legend__swatch" aria-hidden="true" />
        <span>no score yet — municipal or no lot data</span>
      </div>
      <div className="ps-legend__caption">
        Visual ranking only — not a legal determination.
      </div>
    </div>
  );
}
